import { AppID } from '@playq/octopus-common';
import { CheckFileRequest, CheckFilesBatchResponse } from '@playq/octopus2-files';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const emptyArray: [] = [];

export type UseCheckFilesBatchArgs = { appID?: AppID; batch: CheckFileRequest[] };

export const useCheckFilesBatch = (
  { batch }: UseCheckFilesBatchArgs,
  options?: IUseQueryOptionsExtended<CheckFilesBatchResponse | undefined, GenericFailure | Error>
) => {
  const keys = ['fileService', 'checkFilesBatch', ...batch.map((f) => f.serialize())];

  const res = useEitherQuery(keys, () => services2.filesService.checkFilesBatch(batch), {
    ...options,
  });

  return {
    ...res,
    checkedFiles: res.data?.batch ?? emptyArray,
  };
};

export type UseCheckFilesBatchType = typeof useCheckFilesBatch;
